<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4.667 5.901v14.894h22.667V5.9H4.667zM4.334 4c-.92 0-1.667.71-1.667 1.584v15.528c0 .875.746 1.584 1.667 1.584h10v2.07h-3.669c-.552 0-1 .425-1 .95 0 .525.448.95 1 .95h11.333c.553 0 1-.425 1-.95 0-.525-.447-.95-1-.95h-3.664v-2.07h9.333c.92 0 1.667-.71 1.667-1.584V5.584c0-.875-.747-1.584-1.667-1.584H4.334z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'devicesScreenOutline'
}
</script>
